export const HOW_IT_WORKS_ANCHOR = "how-it-works";
export const FAQ_ANCHOR = "faq";

export const STORAGE_SHARE_LINK_KEY = "shareLink";
export const STORAGE_EMAIL_KEY = "userEmail";
